import { render } from "./SmallForm.vue?vue&type=template&id=6639d9e9&ts=true"
import script from "./SmallForm.vue?vue&type=script&lang=ts"
export * from "./SmallForm.vue?vue&type=script&lang=ts"

import exportComponent from "/Users/damodar/Documents/PROGRAMMING/STUDING/everypay/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__